/**
 * 将请求参数变形成 params 参数的形式（key=value&key=value）
 * @param params 请求参数
 * @returns 拼接好 params 参数
 */
export function concatUrl(params: any) {
  const query = Object.keys(params)
    .filter((k) => params[k] || params[k] === 0)
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
  return query;
}

/**
 * 将url中 params 参数变形为对象
 * @returns 对象形式的参数
 */
export function getParams() {
  // 获取当前页面的 URL
  const url = window.location.href;
  // 定义正则表达式，匹配 URL 中的参数名和值
  const pattern = /[?&]([^=#]+)=([^&#]*)/g;
  // 创建一个空对象用于存储参数
  const params: any = {};
  // 循环匹配字符串中所有符合正则表达式的内容，并将其作为参数名和值存储到对象中
  let match;
  while ((match = pattern.exec(url))) {
    const name = decodeURIComponent(match[1]);
    const value = decodeURIComponent(match[2]);
    if (name.length > 0) {
      params[name] = value;
    }
  }
  return params;
}

/**
 * 获取url中指定 key 的 params 参数的值
 * @param key 指定的key
 * @returns 对象形式的参数
 */
export function getParamByKey(key: string) {  
  return getParams()[key];
}

/**
 * 获取cookie
 * @param key cookie的key
 * @returns cookie的value
 */
export function getCookie(key: string): string {
  const cookieList = document.cookie.split(';');
  for (let i = 0; i < cookieList.length; i++) {
    const [cookieKey, cookieValue] = cookieList[i].trim().split('=');
    if (cookieKey === key) {
      return cookieValue;
    }
  }
  return '';
}

/**
 * 设置cookie
 * @param key cookie的key
 * @param value cookie的value
 * @param exdays cookie的过期时间（天数）
 * @param domain cookie的domain
 * @returns
 */
export function setCookie(
  key: string,
  value: string,
  exdays: number = 3,
  domain?: string
) {
  const date = new Date();
  date.setDate(date.getDate() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  const domainStr = domain ? '; domain=' + domain : '';
  document.cookie =
    key + '=' + value + '; ' + expires + '; path=/;' + domainStr;
}

/**
 * 加载图片异步转同步
 * @param src 图片地址
 * @returns 返回一个Promise对象，包含图片元素
 */
export const loadImageElement = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img');
    img.crossOrigin = 'anonymous';
    img.src = src;
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function () {
      reject(img);
    };
  });
};

/**
 * base64 转 blob 
 * @param dataurl base64数据
 * @param filename 文件名
 * @returns 返回转化后的Blob对象
 */
export const dataURLtoFile = (dataurl: string, filename: string) => {
  if (!dataurl || !filename) return;
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/) ? arr[0].match(/:(.*?);/)![1] : null;
  if (!mime) return;
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime }); // if env support File, also can use this: return new File([u8arr], filename, { type: mime });
};

/**
 * 下载文件
 * @param href 下载链接
 * @param filename 文件名
 * @returns 
 */
export const download = (href: string, filename: string) => {
  const a = document.createElement('a');
  a.download = filename;
  a.href = href;
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/**
 * 二进制数据下载文件
 * @param blob 二进制数据
 * @param filename 文件名
 * @returns 
 */
export const downloadBlob = (blob: Blob, filename:string) => {
  const blobUrl = window.URL.createObjectURL(blob);
  download(blobUrl, filename);
  window.URL.revokeObjectURL(blobUrl);
}

/**
 * 校验手机号
 * @param phone 手机号
 * @returns 校验结果
 */
export const checkPhoneNumber = (phone: string) => {
  return /^1[3-9]\d{9}$/.test(phone);
};

/**
 * 校验版本号
 * @param newVersion 新版本号
 * @param oldVersion 旧版本号
 * @returns 校验结果，newVersion >=  oldVersion 则返回 true ,否则返回false
 */
export function compareVersions(newVersion: string, oldVersion: string) {
  const newArr = newVersion.split('.');
  const oldArr = oldVersion.split('.');
  const arr = newArr.length > oldArr.length ? newArr : oldArr;
  let index = 0
  while (index < arr.length) {
    if ((newArr[index] || 0) === (oldArr[index] || 0)) {
        ++index;
    } else {
      return (newArr[index] || 0) > (oldArr[index] || 0);
    }
  }
  return true
}
